import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

function Behaviour({selectedFormId,data,selectedClientDetails}) {
  const { t } = useTranslation();
  const initialFormData =    {
    clientName: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    typeA: false,
    typeT: false,
    session: "",
    date: "",
    practitionerName: "",
    email: "",
    originOfHabit: "",
    // Principal_Complaints: "",
    // Additional_Notes: "",
    dysfunctionalBreathing: {
      "Aborted exhale": false,
      "Gasping, sighing": false,
      "Assisting the inhale": false,
      "Intentional manipulations": false,
      "Avoidance of transition time": false,
      "Mouth breathing": false,
      "Breath holding": false,
      overbreathing: false,
      "Chest breathing": false,
      "Rapid breathing": false,
      "Doing breathing (not allowing)": false,
      "Reverse breathing": false,
      Dysponesis: false,
      "Taking deep breaths": false,
      "Effortful breathing": false,
      underbreathing: false,
      "Forced exhalation": false,
      Other: false,
    
    },
    breathingTriggers: {
      Behaviors: false,
      Memories: false,
      "Breathing mechanics": false,
      "Physical discomfort": false,
      "Breathing self-interventions": false,
      "Postural changes": false,
      "Conversational content": false,
      "Tasks": false,
      "Emotions": false,
      "Thoughts": false,
      "Kinesthetic cues": false,
      Other: false,
      // underline: false,
    },
    motivations: {
      "Access to an alternative sense of self": false,
      "Feeling in control": false,
      "Access to behaviors": false,
      "Feeling of \"getting more oxygen\"": false,
      "Access to emotions": false,
      "Feeling of better self-esteem": false,
      "Access to symptoms": false,
      "Feeling of being \"freer\", safer": false,
      "Access to physical change": false,
      "Feeling of \"deepness in the breath,\" relaxation": false,
      "Avoidance of memories": false,
      "Reduced sense of vulnerability": false,
      "Avoidance of emotions": false,
      "Reduction of air hunger": false,
      "Avoidance of discomfort (pain)": false,
      "Reduction of fear/anxiety": false,
      "Avoidance of thoughts": false,
      "Secondary gain": false,
      "Confirmation of personal interpretations": false,
      "State change": false,
      Stability: false,
      "Familiarity, using favorite muscles": false,
      "Dissociation, disconnectedness": false,
      Other: false,
      // underline: false,
    },
    breathingEmotions: {
      "Allowing the breathing": false,
      "Slowness of the exhale": false,
      "Approaching the end of the exhale": false,
      "Small breaths": false,
      "Breathing in the chest": false,
      "State changes": false,
      "Breathing in the diaphragm": false,
      "Transition time (exhale to inhale)": false,
      "Can't take a deep breath": false,
      "Changes in body sensations": false,
      "Fast breathing": false,
      "Hypocapnic symptoms": false,
      "Nose breathing": false,
      "Slow breathing": false,
      "Others": false,
      // underline: false,
    },
    cognition: {
      "Breathing is \"done\" (not allowed)": false,
      Memories: false,
      "Disruptive thoughts": false,
      "Self-talk": false,
      "Faulty beliefs": false,
      "Symptom misinterpretation": false,
      // underline: false,
    },
    breathingChallenges: {
      "En vivo test": false,
      "Guided breathing": false,
      "Imagination, simulation": false,
      "Mechanics challenge": false,
      "Task challenge": false,
      // underline: false,
    },
    // breathingHabits: {
    //   Type_1_habits: false,
    //   Type_2_habits: false,
    //   Type_3_habits: false,
    //   underline: false,
    // },
  }
  const [formData, setFormData] = useState(data?data:initialFormData);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const keys = name.split(".");
    if (keys.length === 1) {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    } else if (keys.length === 2) {
      const [section, field] = keys;
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: type === "checkbox" ? checked : value,
        },
      }));
    }
  };

const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
const handleSubmit = (e) => {
  e.preventDefault();
  
  
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  setLoading(true);
  const payload = {
    client_id: client_id,
    form_id: selectedFormId,
    form_data: JSON.stringify(formData),
    session_id:  localStorage.getItem("selectedSession") || null,
  };

  fetch(API_URL + "/forms/trainer/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      setLoading(false);
    });
};

  const textareaStyle = {
    width: "100%",
    minHeight: 80,
    padding: 8,
    border: "1px solid #ccc",
    borderRadius: 4,
    outline: "none",
    resize: "vertical",
    backgroundColor: "#f9f9f9",
    marginBottom: 16,
  };

const renderCheckboxSection = (sectionKey, sectionData) => {
  return Object.keys(sectionData).map((key) => (
    <div className="checkbox-item" key={key} style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
      {/* Main checkbox */}
      <input
        type="checkbox"
        name={`${sectionKey}.${key}.checked`}
        checked={formData[sectionKey][key].checked}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            [sectionKey]: {
              ...prev[sectionKey],
              [key]: {
                ...prev[sectionKey][key],
                checked: e.target.checked,
              },
            },
          }))
        }
      />
      {/* Label */}
      <label className="checkbox-label" style={{ marginLeft: 6 }}>{key.replace(/([A-Z])/g, " $1")}</label>
      {/* Underline text input */}
      <input
        type="text"
        name={`${sectionKey}.${key}.text`}
        value={formData[sectionKey][key].text || ""}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            [sectionKey]: {
              ...prev[sectionKey],
              [key]: {
                ...prev[sectionKey][key],
                text: e.target.value,
              },
            },
          }))
        }
        className="checkbox-underline"
        style={{ marginLeft: 8, flex: 1, padding: 4, borderBottom: "1px solid #ccc" }}
      />
    </div>
  ));
};


  return (
    <form onSubmit={handleSubmit} style={{
      fontFamily: "Arial, sans-serif",
        maxWidth: "1200px",
        margin: "20px auto",
        padding: !data?"20px":"10px",
      border: !data && "1px solid #ccc",
    }}>
      <h1 style={{ fontSize: "24px", marginTop: 20, marginBottom: 20 }}>
        BEHAVIOR REPORT
      </h1>

      {/* Client Info */}
      <div className="client-info">
        <div className="client-info-item">
          <label>Client Name:</label>
          <input
            name="clientName"
            value={formData.clientName}
            onChange={handleInputChange}
            disabled={Boolean(selectedClientDetails)}
            style={{
              width: "310px",
              border: "none",
              borderBottom: "1px solid black",
              backgroundColor: "#f1f4ff",
            }}
          />
        </div>

        <div className="client-info-item">
          <label style={{ marginRight: 10 }}>Type:</label>
          <div className="type-checkboxes">
            <input
              type="checkbox"
              id="typeA"
              name="typeA"
              checked={formData.typeA}
              onChange={handleInputChange}
            />
            <label htmlFor="typeA" className="checkbox-label-small">
              A
            </label>
            <input
              type="checkbox"
              id="typeT"
              name="typeT"
              checked={formData.typeT}
              onChange={handleInputChange}
            />
            <label htmlFor="typeT" className="checkbox-label-small">
              T
            </label>
          </div>
        </div>

        <div className="client-info-item">
          <label>Session #</label>
          <input
            name="session"
            value={formData.session}
            onChange={handleInputChange}
            style={{
              width: "50px",
              border: "none",
              borderBottom: "1px solid black",
              backgroundColor: "#f1f4ff",
            }}
          />
        </div>

        <div className="client-info-item">
          <label>Date:</label>
          <input
            type="text"
            name="date"
            value={formData.date}
            onChange={handleInputChange}
            style={{
              width: "100px",
              border: "none",
              borderBottom: "1px solid black",
              backgroundColor: "#f1f4ff",
            }}
          />
        </div>
      </div>

      {/* Practitioner Info */}
      <div className="form-row">
        <label>Practitioner Name:</label>
        <input
          name="practitionerName"
          value={formData.practitionerName}
          onChange={handleInputChange}
          style={{
            flex: 1,
            border: "none",
            borderBottom: "1px solid black",
            backgroundColor: "#f1f4ff",
          }}
        />
        <label>Email:</label>
        <input
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          style={{
            flex: 1,
            border: "none",
            borderBottom: "1px solid black",
            backgroundColor: "#f1f4ff",
          }}
        />
      </div>

      <div className="form-row">
        <label>Possible origin of habit</label>
        <input
          name="originOfHabit"
          value={formData.originOfHabit}
          onChange={handleInputChange}
          style={{
            flex: 1,
            border: "none",
            borderBottom: "1px solid black",
            backgroundColor: "#f1f4ff",
          }}
        />
      </div>

   

    

      {/* Sections */}
      <div className="section-title">Dysfunctional breathing behaviors:</div>
      <div className="checkbox-grid">
        {renderCheckboxSection("dysfunctionalBreathing", formData.dysfunctionalBreathing)}
      </div>

      <div className="section-title">Breathing habit triggers observed DURING INTERVIEW:</div>
        <div className="checkbox-grid">
        {renderCheckboxSection("breathingTriggers", formData.breathingTriggers)}
      </div>

      <div className="section-title">
        Motivations & reinforcements of dysfunctional breathing habits:
      </div>
      <div className="checkbox-grid">
        {renderCheckboxSection("motivations", formData.motivations)}
      </div>

      <div className="section-title">
        Breathing behaviors and symptoms that trigger learned emotions:
      </div>
      <div className="checkbox-grid">
        {renderCheckboxSection("breathingEmotions", formData.breathingEmotions)}
      </div>

      <div className="section-title">Cognition associated with breathing:</div>
      <div className="checkbox-grid">
        {renderCheckboxSection("cognition", formData.cognition)}
      </div>

      <div className="section-title">
        Breathing challenges used and outcomes (See Guided Overbreathing Record):
      </div>
      <div className="checkbox-grid">
        {renderCheckboxSection("breathingChallenges", formData.breathingChallenges)}
      </div>


    

      {/* Submit Button */}
            {!data && <div className="client-submit-btn">
        <button type="submit">{loading?t("Submitting..."):t("Submit")}</button>
      </div>}
       <Modal
                                            isOpen={successModal}
                                            toggle={successToggleModal}
                                            className="connect-box"
                                            centered={true}
                                          >
                                            <ModalHeader toggle={successToggleModal}>
                                              <span className="ml-1 roititle font-weight-bold">
                                                Successfull
                                              </span>
                                            </ModalHeader>
                                            <ModalBody>
                                              <div className="modal-p">
                                                <p>Trainer form has been submitted successfully.</p>
                                              </div>
                                            </ModalBody>
                                          </Modal>
    </form>
  );
}

export default Behaviour;

